import { useMsal } from '@azure/msal-react';
import { useAppConfig } from '../appConfig';
/** Hook that returns a pre-configured sign out handler */
export const useSignOutFunction = () => {
    var _a;
    const { usePopupFlow } = useAppConfig();
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    const logoutHint = (account === null || account === void 0 ? void 0 : account.homeAccountId) || (account === null || account === void 0 ? void 0 : account.username) || ((_a = account === null || account === void 0 ? void 0 : account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.upn);
    return () => {
        if (usePopupFlow) {
            return instance.logoutPopup({
                account,
                logoutHint,
                mainWindowRedirectUri: window.location.href,
            });
        }
        else {
            // Supposedly MSAL handles the actual return URL for us on logout.
            return instance.logoutRedirect({
                account,
                logoutHint,
            });
        }
    };
};
